export default __webpack_public_path__ + "static/media/step1.15325d88.svg";